import { Breadcrumb } from './observability.types';

const MAX_BREADCRUMBS = 30;

const buffer: Breadcrumb[] = [];

export const addBreadcrumb = (b: Omit<Breadcrumb, 'ts'>): void => {
  buffer.push({ ts: Date.now(), ...b });
  if (buffer.length > MAX_BREADCRUMBS) {
    buffer.shift();
  }
};

export const getBreadcrumbs = (): Breadcrumb[] => buffer.slice();

export const clearBreadcrumbs = (): void => {
  buffer.length = 0;
};
